import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { DEMO_PERMISSIONS } from "config/demoSession.ts";
import type { RootState } from "app/store.ts";
import type { PagePermissions, PermissionsParsed } from "./permissionsTypes.ts";
import { registerPermissionModuleUsage } from "./permissionModuleInspector.ts";

const storedPermissions = sessionStorage.getItem("permissions");
const isBypassActive = sessionStorage.getItem("loginBypass") === "true";
const permissions: PermissionsParsed | null = storedPermissions
  ? JSON.parse(storedPermissions)
  : isBypassActive
    ? DEMO_PERMISSIONS
    : null;

const initialState = permissions;

const EMPTY_PAGE_PERMISSIONS: PagePermissions = {
  isCreate: undefined,
  isDelete: undefined,
  isRead: undefined,
  isUpdate: undefined,
};

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissions: (_, action: PayloadAction<PermissionsParsed>) =>
      action.payload,
    removePermissions: () => null,
  },
});

export const { setPermissions, removePermissions } = permissionsSlice.actions;

export const selectPermissions = (state: RootState) => state.permissions;
export const selectPagePermissions = (
  state: RootState,
  itemId: keyof PermissionsParsed,
): PagePermissions => {
  const pages = selectPermissions(state);
  const pagePermissions = pages?.[itemId] ?? EMPTY_PAGE_PERMISSIONS;

  if (typeof window !== "undefined") {
    registerPermissionModuleUsage(String(itemId), pagePermissions);
  }

  return pagePermissions;
};

export default permissionsSlice.reducer;
